import * as React from "react";

const LinkedinIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="3" fill="#0A66C2"></rect>
    <path
      fill="#FFFFFF"
      d="M20.5 2h-17C2.7 2 2 2.7 2 3.5v17c0 .8.7 1.5 1.5 1.5h17c.8 0 1.5-.7 1.5-1.5v-17c0-.8-.7-1.5-1.5-1.5zM8 19H5V9h3v10zM6.5 7.7c-1 0-1.7-.8-1.7-1.7s.8-1.7 1.7-1.7c1 0 1.7.8 1.7 1.7 0 1-.7 1.7-1.7 1.7zM19 19h-3v-5.3c0-1.4-.6-1.9-1.4-1.9-.8 0-1.6.6-1.6 2v5.2h-3V9h2.9v1.4c.3-.6 1.3-1.6 2.8-1.6 1.7 0 3.4 1 3.4 3.7V19z"
    ></path>
  </svg>
);

export default LinkedinIcon;
